export const UNSPLASH_SERVICE = 'unsplash';
export const GIPHY_SERVICE = 'giphy';
export const CANVA_SERVICE = 'canva';
export const DROPBOX_SERVICE = 'dropbox';
export const GOOGLE_PHOTOS_SERVICE = 'googlephotos';
export const GOOGLE_DRIVE_SERVICE = 'googledrive';
export const ONE_DRIVE_SERVICE = 'onedrive';
